export default "__VITE_ASSET__DzP_JhzF__"